///<reference path="mixitup.d.ts" />
import * as mixitup from 'mixitup';
import Alpine from 'alpinejs'
Alpine.start();
import { Fancybox } from '@fancyapps/ui';

Fancybox.bind("[data-fancybox]", {});

/**
 * Mixitup
*/
const configDefault = {
  controls: {
    scope: 'local',
  },
};

if (document.body.contains(document.querySelector('.contact-block'))) {
  var contactMixer = mixitup('.contact-block', configDefault);
}

/**
 * Mobile-toggle
*/
const navToggle = document.querySelector("#nav-toggle");
  const navLayout = document.querySelector(".mobile-navigation");

navToggle.addEventListener("click", (e) => {
  navToggle.classList.toggle("nav-toggle--active");
  navLayout.classList.toggle("mobile-navigation--open");


  if (document.body.style.overflow === "hidden") {
    document.body.style.overflow = "";
  } else {
    document.body.style.overflow = "hidden";
  }
})



// Lyssna på tangentbordstryck
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && navLayout.classList.contains("mobile-navigation--open")) {
    navToggle.classList.remove("nav-toggle--active");
    navLayout.classList.remove("mobile-navigation--open");
  }
});


/**
 * Header | Hover effect on level 1 of dropdown
*/

if (document.body.contains(document.querySelector('.dropdown'))) {
  const dropdown = document.querySelector(".dropdown");

  dropdown.querySelectorAll(".dropdown-level-2").forEach(element => {
    element.addEventListener("mouseover", (e) => {
      const dropdownLvl1 = element.previousElementSibling;

      if (!dropdownLvl1.classList.contains("hover")) {
        dropdownLvl1.classList.add("hover");
      }
    });
  });

  dropdown.querySelectorAll(".dropdown-level-2").forEach(element => {
    element.addEventListener("mouseleave", (e) => {
      const dropdownLvl1 = element.previousElementSibling

      if (dropdownLvl1.classList.contains("hover")) {
        dropdownLvl1.classList.remove("hover");
      }
    });
  });
}

/**
 * Träcentrum | Decrease menu-size on scroll
 */
const menu = document.querySelector(".site-header");
document.addEventListener("scroll", () => {
  // use document.documentElement for chrome, firefox, ie or opera
  // and document.body for safari since that's where overflow is set in those browsers
  if (document.documentElement.scrollTop > 0){
    menu.classList.add("page--scrolled");
    document.body.classList.add("scrolled");
  }
  else{
    menu.classList.remove("page--scrolled");
    document.body.classList.remove("scrolled");
  }
});
